function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1",
  "data-name": "Group 1",
  transform: "translate(-270.071 -221.567)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1",
  "data-name": "Path 1",
  d: "M287.168,353.742l-6.2,10.628-6.213-10.628h-4.577v19.416h4.133V360.4l5.464,9.693h2.372l5.477-9.693v12.754h4.133V353.742ZM313.9,361.8l-4.373-8.058H305.3l6.569,11.982v7.434H316v-7.434l6.486-11.982h-4.225L313.9,361.8Zm32.321-8.058v19.416h8.2a10.4,10.4,0,0,0,7.022-2.575,10.2,10.2,0,0,0,0-14.275,10.433,10.433,0,0,0-7.022-2.566Zm4.133,15.81v-12.2h4.068a5.977,5.977,0,0,1,4.281,1.6,6.818,6.818,0,0,1,0,9,5.987,5.987,0,0,1-4.281,1.609Zm27.511-15.81v19.416H382V353.742Zm32.333,0H396.846v19.416H410.2v-3.606h-9.222v-4.41h7.581V361.73h-7.581v-4.382H410.2v-3.606Zm14.577,0v3.606h5.769v15.81h4.133v-15.81h5.741v-3.606Zm51.867,0-7.489,9.222v-9.222h-4.133v19.416h4.133v-4.822l2.261-2.787,5.228,7.609h4.3L473.8,362.585l7.146-8.843Zm37.08,19.416-7.586-19.416h-4.521l-7.586,19.416h4.212l1.34-3.578h8.589l1.341,3.578Zm-9.846-15.14,2.954,7.956h-5.908l2.954-7.956Zm35.582,8.159a5.775,5.775,0,0,0,2.487-2.32,7,7,0,0,0,.925-3.606,6.576,6.576,0,0,0-1.734-4.674,5.665,5.665,0,0,0-4.262-1.835h-9.9v19.416h4.132v-6.384h4.5l3.749,6.384h4.3l-4.207-6.981Zm-3.384-8.829a2.527,2.527,0,0,1,1.9.8,3.546,3.546,0,0,1,0,4.382,2.506,2.506,0,0,1-1.9.813h-4.965v-5.995Zm19.783-3.606v3.606h5.769v15.81h4.132v-15.81H571.5v-3.606Z",
  fill: "#e2e1e0",
  stroke: "#e2e1e0",
  strokeMiterlimit: 22.926,
  strokeWidth: 0.216,
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2",
  "data-name": "Path 2",
  d: "M491.934,221.6H548.3l-46.046,46.047H491.934V221.6Zm79.775,3.71h0v5.634L523.4,279.252l48.312,48.311h0V225.3Zm-23.73,111.348H491.934V290.862h10.322Z",
  fill: "#99e5cb",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3",
  "data-name": "Path 3",
  d: "M402.751,233.343c11.424-.469,23.816-.035,35.347-.035,13.425,0,19.755-.674,29.228,6.32,6.126,4.524,11.271,12.584,11.308,24.182.037,11.432.5,24.15-.07,35.441a28.435,28.435,0,0,1-12.99,22.531c-9.073,5.955-17.807,4.962-30.438,5.036l-70.946-.07.3-30.528,21.441-30.647.011,39.464c15.681.306,31.69.014,47.42.014,26.634,0,23.474,2.147,23.474-24.36,0-19.269,2.74-25.611-10.146-25.579l-59.961.005-58.392,81.724,155.546.005L484,221.6l-72.7.064Z",
  fill: "#e2e1e0",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4",
  "data-name": "Path 4",
  d: "M270.179,336.841l47.542-.032L331.309,318.3l-33.772-48.237-.056,56.776-21.715-.018-.077-93.553,22.988.03,37.837,53.874,37.9-53.837,18.665-.044,8.251-11.729-131.045.01Z",
  fill: "#99e5cb",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1",
  "data-name": "Rectangle 1",
  width: 79.731,
  height: 11.626,
  transform: "translate(491.979 221.569)",
  fill: "#99e5cb"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2",
  "data-name": "Rectangle 2",
  width: 79.731,
  height: 11.626,
  transform: "translate(491.979 325.027)",
  fill: "#99e5cb"
}));

function SvgNewLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 301.64,
    height: 151.699,
    viewBox: "0 0 301.64 151.699",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogo);
export default __webpack_public_path__ + "static/media/NEWLogo.a76fdff6.svg";
export { ForwardRef as ReactComponent };